export default "__VITE_ASSET__a768cbdb__"